const main = () => {
    if (document.querySelector('.l-hamburger') === null) return;

    document.querySelectorAll('[data-open-hamburger]').forEach((element) => {
        element.addEventListener('click', (e) => {
            e.preventDefault();
            document.body.toggleAttribute('data-menu-active');
        });
    });
};

export default main;
